export const environment = {
  production: false,
  name: 'dev',
  showVersionBadge: true,
  version: '1.4.3',
  apiBaseUrl: 'https://dev.phdcompass.net/api',
  awsRegion: 'eu-west-1'
};
